import {lazy} from './lazy.js';
import {updatePlanarSize, WIDTH, HEIGHT, PADDING} from 'components/effects/plane/constants.js';
import {getCentroid} from './geometry.js';
const geometry = getCentroid;

const cos = Math.cos;
const sin = Math.sin;
let ctxt = undefined;

let dist = (a,b) => Math.sqrt(
    Math.pow(a.x - b.x, 2) + 
        Math.pow(a.y - b.y, 2));

export const circle = (radiusFactor=1, interpolation=1) => {
    const interpolate = (a, b, inter) => {
        return {
            x:inter*a.x + (1 - inter)*b.x,
            y:inter*a.y + (1 - inter)*b.y,
        };
    };
    
    return (...args) => {
        let [coords] = args;
        let _interpolation = lazy(
            interpolation, ...args);
        let {
            x, y, diameter
        } = geometry()(...args);
        
        let _coords = {
        };
        let pi = Math.PI;
        let r = (diameter / 2) * lazy(
            radiusFactor, ...args);
        let length = Object.keys(
            coords).length;
        
        let values = Object.keys(
            coords).map(
                id => ({
                    ...coords[id],
                    id
                }));
        
        for (let i=1; i <= length; i++) {
            let ang = 2 * pi * (i / length);
            let _x = x + r * cos(ang);
            let _y = y + r * sin(ang);
            
            let pt = {
                x:_x, y:_y
            };
            
            // find closet param to _x,_y and 
            // set it to here
            let sorted = values.sort(
                (a,b) => dist(a, pt) - dist(b, pt));
            let {
                id
            } = sorted[0];
            _coords[id] = interpolate(
                pt, coords[id], _interpolation);
            
            values = sorted.slice(1);
        }
        return  _coords;
    };
};

/*
 * prevents 2 macros from intersecting
 */
export const preventIntersect = (a, b) => {
    return (...args) => {
        let effect  = args[6];

        if (!ctxt) {
            var canvas = document.createElement("canvas");
            canvas.width = WIDTH;
            canvas.height = HEIGHT;
            ctxt = canvas.getContext('2d');
        }

        let macroA = effect.macros.find(
            m => m.number === a);
        let macroB = effect.macros.find(
            m => m.number === b);

        if (!macroA || !macroB) {
            return args[0];
        }

        let pathA = new Path2D(macroA.getEasyBlob());
        let pathB = new Path2D(macroB.getEasyBlob());

        // now loop thru the macroB points and see if they
        // isPointInPath

        let ids = macroB.parameters.map(x => x.id);
        let coords = { ... args[0]};
        for (let id of ids) {
            let coord = coords[id];
            if (!coord) {
                continue;
            }

            let {x,y} = coord;
            let i=0;
            // todo: alggo for resolving interesctions sould be passsed in
            while (ctxt.isPointInPath(pathA, x, y) && (i++) < 25) {
                x = (x + 5) % WIDTH;
                y = (y + 5) % HEIGHT;
            }
            coords[id] = {
                ... coords[id],
                x,
                y
            };
        }
        return coords;
    };
};
